import { Dialog as BaseDialog } from '@base-ui/react';
import { useState } from 'react';

export const useHandle = <Payload>() => {
  const [handle] = useState(() => BaseDialog.createHandle<Payload>());

  return handle;
};
